/**
 * LiveRewind entity class
 */

/**
 * LiveRewindFactory
 * returns LiveRewind entity class
 *
 * @class LiveRewindFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.LiveRewind} class
 *
 * @ngdoc factory
 * @name mwApp.factory:LiveRewindFactory
 */
/* @ngInject */
export default function LiveRewindFactory ($http, alertLiteSvc, Entity, Type, onOffMixin) {
  /* === LiveRewind class === */

  /**
   * LiveRewind model
   *
   * @class LiveRewind
   * @classdesc LiveRewind model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.LiveRewind} LiveRewind entity
   */
  function LiveRewind () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  LiveRewind.prototype = Object.create(Entity.prototype)
  LiveRewind.prototype.constructor = LiveRewind

  /* === LiveRewind instance methods & fields === */

  Object.assign(LiveRewind.prototype, {

    /**
     * instance fields
     *
     * @memberof models.LiveRewind#
     * @type {Object}
     */
    _fields: {
      id: Number,
      enabled: Boolean,
      channel: Type.Stump('Channel', ['id', 'name', 'enabled', 'channelType']),
      mediaUrl: 'MediaUrlDTO',
      options: [String],
      providerType: String,
      rewindLengthSec: Number,
      storageDurationSec: Number,
      status: String,
      $customUrl: false,
      $rewindLength: Number,
      $storageDuration: Number
    },

    /**
     * url template
     *
     * @memberof models.LiveRewind#
     * @type {String}
     */
    _urlTemplate: 'api/channels/services/liverewinds/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.LiveRewind#
     * @type {String}
     */
    _publicUrlTemplate: 'channels/services/liverewinds/{{::id}}',

    /**
     * Prepare channel
     *
     * @memberof models.LiveRewind#
     * @override
     */
    _prepare: function () {
      this.$customUrl = !!this.mediaUrl
      this.$rewindLength = this.rewindLengthSec ? this.rewindLengthSec / 3600 : null
      this.$storageDuration = this.storageDurationSec ? this.storageDurationSec / 3600 : null
    },

    /**
     * Get underlying object
     *
     * @memberof models.LiveRewind#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      if (this.mediaUrl && this.mediaUrl.drmProfiles && this.mediaUrl.drmProfiles.length && this.mediaUrl.drmProfiles[0].providerType === 'EXPRESS_PLAY') {
        this.mediaUrl.playbackTokenGeneratorId = null
      }
      if (this.mediaUrl && !this.mediaUrl.extchecked) this.mediaUrl.playbackTokenGeneratorId = null
      this.mediaUrl = this.$customUrl ? this.mediaUrl : null
      this.rewindLengthSec = this.$rewindLength ? this.$rewindLength * 3600 : null
      this.storageDurationSec = this.$storageDuration ? this.$storageDuration * 3600 : null

      var ret = Entity.prototype._object.apply(this, arguments)

      // remove fields, specific only for list
      delete ret.status

      return ret
    }

  }, onOffMixin)

  /* === LiveRewind static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(LiveRewind, Entity)
  LiveRewind._name = 'LiveRewind'
  LiveRewind.init()

  // permissions
  LiveRewind.access = {
    view: 'viewLiveRewind',
    create: 'createLiveRewind',
    edit: 'editLiveRewind',
    delete: 'deleteLiveRewind'
  }

  // extra
  LiveRewind.extra = {
    channels: ['Channel'],
    playbackTokenGenerators: ['PlaybackTokenGenerator'],
    drmProfiles: ['DRMProfile']
  }

  return LiveRewind
}
